import { CircularProgress } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { configPayload, tokenExpireTime } from '../../config';
import { globalVal } from '../../global/globalvalues';
import { GetCustomer } from '../../store/Checkout/actions';
import { getInTouch } from '../../store/HomePage/actions';
import './AstoundLogin.scss';
import { config } from '../../store/Billing/actions';

type Props = {
    history: any;
};

const AstoundLogin = (props: Props) => {
    const [cookies, setCookie] = useCookies(['astoundAccessToken']);
    const dispatch = useDispatch();
    const { getCustomer, errorGetCustomer } = useSelector((state: any) => state.checkout);

    const { history } = props;

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tokenId: any = urlSearchParams.get('id_token');
        if (tokenId) {
            setCookie('astoundAccessToken', tokenId, {
                maxAge: tokenExpireTime,
                secure: true,
            });
            localStorage.setItem('astoundAccessToken', tokenId);
        }
        let ssoToken = cookies.astoundAccessToken;
        let ssoCustomerDetails: any = localStorage.getItem('ssoCustomerDetails');
        if (ssoToken || tokenId) {
            if (ssoCustomerDetails) {
                ssoCustomerDetails = JSON.parse(ssoCustomerDetails);
                dispatch(
                    GetCustomer({
                        username: encodeURIComponent(
                            ssoCustomerDetails.NameID ? ssoCustomerDetails.NameID : ssoCustomerDetails.email,
                        ),
                    }),
                );
            } else {
                let data = parseJwt(tokenId ? tokenId : ssoToken);
                localStorage.setItem('ssoCustomerDetails', JSON.stringify(data));
                dispatch(
                    GetCustomer({
                        username: encodeURIComponent(data.NameID ? data.NameID : data.email),
                    }),
                );
            }
        } else {
            window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_LOGIN_URL}`;
        }
    }, []);

    useEffect(() => {
        if (getCustomer && getCustomer.status === 'SUCCESS' && getCustomer.data) {
            dispatch(config(configPayload))
            dispatch(
                getInTouch({
                    data: {
                        emailId: getCustomer.data && getCustomer.data.emailId,
                        hubspotMap: {
                            email: getCustomer.data && getCustomer.data.emailId,
                            is_test: globalVal.hubspot_is_test,
                            is_qa: globalVal.hubspot_is_qa,
                            website_logged_in: true,
                            website_login_date: new Date().getTime(),
                            website_journey_score: 3,
                            firstname: getCustomer.data && getCustomer.data.firstName,
                            lastname: getCustomer.data && getCustomer.data.lastName,
                        },
                    },
                }),
            );
            if (getCustomer.data.status === 0) {
                history.push({ pathname: '/home', state: getCustomer.data });
            } else if (
                getCustomer.data.status == 1 ||
                getCustomer.data.status == 2 ||
                getCustomer.data.status == 3 ||
                getCustomer.data.status == 4 ||
                getCustomer.data.status == 5 ||
                getCustomer.data.status == 7 ||
                getCustomer.data.status == 8 ||
                getCustomer.data.status == 9 ||
                getCustomer.data.status == 10 ||
                getCustomer.data.status == 11
            ) {
                history.push('/post-activation-home');
            }
        }
    }, [getCustomer]);

    useEffect(() => {
        if (
            errorGetCustomer &&
            errorGetCustomer.status === 'FAILURE' &&
            errorGetCustomer.resCode === 40003 &&
            errorGetCustomer.exCode === 'CUSTOMER_NOT_FOUND'
        ) {
            history.push('/user');
        }
    }, [errorGetCustomer]);

    const parseJwt = (token: any) => {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
        );
        return JSON.parse(jsonPayload);
    };

    return (
        <div className="loader">
            <CircularProgress />
        </div>
    );
};

export default AstoundLogin;
